import React, { Component } from 'react';
import './Hand.css';
import Card from '../../components/cards/Card';
import Library from '../utility/Library';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import { read, getLanguage } from '../../TextManager';

const statuses = Object.values(Library.statuses);
const lang = getLanguage();

export default class Hand extends Component {

  state = {
    info: null,
    tooltip: null
  }

  componentDidMount () {

    this.resizehandler = () => this.forceUpdate();
    window.addEventListener('resize', this.resizehandler);
  }

  componentWillUnmount () {

    window.removeEventListener('resize', this.resizehandler);
  }

  info (card) {

    if (this.props.targeting)
      return;
    if (this.state.info !== card)
      this.setState({info: card})
  }

  liveInfo () {

    const info = this.state.info;
    if (!info?.id)
      return info;
    return this.props.manager?.run?.room?.fight?.find(info.id) || this.props.src.master.find(info.id) || info;
  }

  computeEffect (text) {

    if (!text)
      return "";
    const info = this.liveInfo();
    text = this.corruptText(text, info);
    const computeText = compute => {
      let computetype = "";
      switch (compute.type) {
      case "attack": computetype = "D:"; break;
      case "block": computetype = "B:"; break;
      case "momentum": computetype = "M:"; break;
      case "overgrowth": computetype = "O:"; break;
      case "heal": return "H:" + (compute.value > 0 ? compute.value : 0);
      case "exp": computetype = "E:"; break;
      default: computetype = "V:"; break;
      }
      return computetype + (compute.value > 0 ? compute.value : 0) + (compute.type === "overgrowth" ? "%" : "");
    }
    if (info && info.compute && (!this.props.targeting || this.props.targeting.id.no === info.id.no)) {
      let compute = info.compute();
      let computed = compute.type ? computeText(compute) : null;
      if (computed)
        text += " (" + computed + ")"
    } else if (info && info.model?.skill && this.props.manager.run.room.fight.player.compute) {
      let compute = this.props.manager.run.room.fight.player.compute();
      let computed = compute.type ? computeText(compute) : null;
      if (computed)
        text += " (" + computed + ")"
    }

    let splits = [];
    // eslint-disable-next-line
    let texts = text.split(/\[[^\[]+\]|\{[^\{]+\}|\<[^\<]+\>|\n|D:\d+|B:\d+|M:\d+|O:\d+%|\(H:\d+\)|E:\d+|V:\d+|F:\d+/);
    // eslint-disable-next-line
    let matches = text.match(/\[[^\[]+\]|\{[^\{]+\}|\<[^\<]+\>|\n|D:\d+|B:\d+|M:\d+|O:\d+%|\(H:\d+\)|E:\d+|V:\d+|F:\d+/g);
    if (matches)
      matches.forEach((match,i) => {
        let el = match.slice(1, -1);
        splits.push(<span key={i+"a"}>{ texts[i] }</span>);
        if (match[0] === '{') {
          let el = match.substring(1, match.length - 1);
          let slices = el.split(':');
          let key = slices[0];
          splits.push(<span className="token" onClick={() => this.props.onFocus(Library.cards[key])} key={i}>{Library.cards[key].name}</span>);
          /*let slices = el.split('/');
          let key = slices[0];
          let ntoken = this.state.token.slice(); ntoken.push(Library.cards[key]);
          let repeat = this.current.key && key === this.current.key.toString();
          splits.push(<span onClick={repeat ? () => {} : () => this.setState({tooltip: null, token: ntoken})} key={i} className={"token" + (repeat ? " repeat-token" : "")} id={'effect-' + i}>{ slices.length > 1 ? slices[1] : Library.cards[key].name }</span>);*/
        } else if (match[0] === '[') {
          let slices = el.split('/');
          let keyword = slices[0];
          let status = statuses.filter(s => s.translations && s.translations.en.name === keyword)[0];
          if (status) {
            splits.push(<span key={i} className={"keyword" + (status.translations[lang].effect ? "" : " unlabelled") + (status.soft ? " soft" : "")} id={'effect-' + i} onClick={() => this.toggleTooltip(i)}>{status.keyword ? "" : <Img key={keyword + '-' + i} className="keyword-icon" src={"/images/statuses/" + keyword + ".png"} alt=""/>}{slices.length > 1 ? slices[1] : status.translations[lang].name}</span>);
            splits.push(<Tooltip key={i+"t"} className="tooltip" placement="top" isOpen={this.state.tooltip === i} target={"effect-" + i} toggle={() => this.toggleTooltip(i)}>{ status.translations[lang].effect }</Tooltip>);
          }
        } else if (match[0] === '<') {
          let param = el;
          let value = info.getStatValue(param);
          if (info.modifyTensionSpendCost && this.isTensionSpendToken(texts, matches, i) && (!info.spendsUpToTension || !info.spendsUpToTension()) && (!info.ignoresTensionSpendModifiers || !info.ignoresTensionSpendModifiers()))
            value = info.modifyTensionSpendCost(value);
          let className = "";
          const displayStatusBoosts = info.model.displayStatusBoosts?.[param];
          if (displayStatusBoosts)
            Object.keys(displayStatusBoosts).forEach(status => {
              value += this.props.src.master.player.getStatusValue(status) * displayStatusBoosts[status];
            });
          const overgrowthBoost = info.model.displayOvergrowthBoosts?.[param];
          if (overgrowthBoost)
            value = Math.round(value + this.props.src.master.player.computeOvergrowthCardBonus(value, info) * overgrowthBoost);
          if (this.isExpToken(texts, matches, i)) {
            className = "num-effect exp-effect";
            if (info.corrupt && !info.fullCorruptActive)
              value = 0;
          }
          else if (param.includes("damage")) {
            className = "num-effect damage-effect";
            if (this.props.src.master.run.champion.getPassive("strikedefendmultiplier") && info.model.name === "Strike")
              value *= this.props.src.master.run.champion.getPassive("strikedefendmultiplier");
            value = this.props.target ? this.props.target.modifyDamageIn(value, this.props.src.master.player, info) : this.props.src.master.player.modifyDamageOut(value, info);
          }
          else if (param.includes("block")) {
            className = "num-effect block-effect";
            if (this.props.src.master.run.champion.getPassive("strikedefendmultiplier") && info.model.name === "Defend")
              value *= this.props.src.master.run.champion.getPassive("strikedefendmultiplier");
            value = this.props.src.master.player.modifyBlock(value, info);
          }
          else if (param.includes("momentum")) {
            className = "num-effect momentum-effect";
            value = this.props.src.master.player.modifyStatusApply(value, "momentum", info);
          }
          else if (param === "totalweak") {
            value = Math.round(value + this.props.src.master.player.computeOvergrowthCardBonus(value, info));
          }
          else if (param.includes("heal")) {
            className = "num-effect heal-effect";
            if (info.recovery && !info.fullRecoveryActive)
              value = info.recoveryHealAmount(value);
          }
          splits.push(<span key={i} className={className}>{value}</span>);
        } else if (match[0] === '\n') {
          splits.push(<br key={i}/>);
        } else if (match[0] === 'D') {
          let initialvalue = parseInt(match.substring(2), 10);
          if (this.props.src.master.run.champion.getPassive("strikedefendmultiplier") && info.model.name === "Strike")
            initialvalue *= this.props.src.master.run.champion.getPassive("strikedefendmultiplier");
          let damage = this.props.target ? this.props.target.modifyDamageIn(initialvalue, this.props.src.master.player, info) : this.props.src.master.player.modifyDamageOut(initialvalue, info);
          splits.push(<span key={i} className="num-effect damage-effect">{ damage }</span>);
        } else if (match[0] === 'B') {
          let initialvalue = parseInt(match.substring(2), 10);
          if (this.props.src.master.run.champion.getPassive("strikedefendmultiplier") && info.model.name === "Defend")
            initialvalue *= this.props.src.master.run.champion.getPassive("strikedefendmultiplier");
          let block = this.props.src.master.player.modifyBlock(initialvalue, info);
          splits.push(<span key={i} className="num-effect block-effect">{ block }</span>);
        } else if (match[0] === 'M') {
          let initialvalue = parseInt(match.substring(2), 10);
          let momentum = this.props.src.master.player.modifyStatusApply(initialvalue, "momentum", info);
          splits.push(<span key={i} className="num-effect momentum-effect">{ momentum }</span>);
        } else if (match[0] === 'O') {
          let initialvalue = parseInt(match.substring(2), 10);
          splits.push(<span key={i} className="num-effect othervalue-effect">{ initialvalue + "%" }</span>);
        } else if (match[0] === '(') {
          let initialvalue = parseInt(match.substring(3), 10);
          splits.push(<span key={i} className="num-effect heal-effect">{ "(up to " + initialvalue + ")" }</span>);
        } else if (match[0] === 'E') {
          let initialvalue = parseInt(match.substring(2), 10);
          splits.push(<span key={i} className="num-effect exp-effect">{ initialvalue }</span>);
        } else if (match[0] === 'V') {
          let initialvalue = parseInt(match.substring(2), 10);
          //let block = this.props.src.master.player.modifyBlock(initialvalue, this.state.info);
          splits.push(<span key={i} className="num-effect othervalue-effect">{ initialvalue }</span>);
        } else if (match[0] === 'F') {
          let initialvalue = parseInt(match.substring(2), 10);
          splits.push(<span key={i} className="num-effect othervalue-effect">{ initialvalue }</span>);
        }
      });
    splits.push(<span key={"end"}>{ texts[texts.length-1] }</span>);
    return splits;
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  effectLength (effect, info) {

    effect = this.corruptText(effect || "", info);
    let length = effect.length;
    if (length > 120)
      return "reallylong";
    if (length > 85)
      return "verylong";
    if (length > 60)
      return "long";
    return "regular";
  }

  isTensionSpendToken (texts, matches, index) {

    const before = texts[index] || "";
    const between = texts[index + 1] || "";
    const next = matches[index + 1] || "";
    return /spend(?: up to)?\s*$/i.test(before) && /^\s*$/.test(between) && /^\[Tension\]$/i.test(next);
  }

  isExpToken (texts, matches, index) {

    const between = texts[index + 1] || "";
    const next = matches[index + 1] || "";
    return /^\s*$/.test(between) && /^\[Exp\]$/i.test(next);
  }

  corruptText (text, info) {

    if (!text)
      return "";
    if (info?.corrupt && !info.fullCorruptActive)
      return text.replace(/##[\s\S]*?##/g, "");
    return text.replace(/##/g, "");
  }

  render () {

    const activeInfo = this.props.targeting || this.state.info;
    const activeEffect = activeInfo?.model.effect || activeInfo?.model.skill?.effect;
    const liveInfo = this.liveInfo();

    return (
      <div className="game-hand">
      {
        activeInfo ?
        <div className="game-card-info">
          <div className="game-card-info-inner">
            <div className="game-card-info-type">{read('cards/' + (activeInfo.type || "skill"))}</div>
            <div className={"game-card-info-effect game-effect text-" + this.effectLength(activeEffect, liveInfo)}>{
              this.computeEffect(activeEffect)
            }</div>
          </div>
        </div> : ""
      }
      {
        this.props.src.cards.map((c,i) => {
          let focus = this.props.focus && this.props.focus === c;
          let center = (this.props.src.cards.length-1)/2;
          var shift = i-center;
          let deg = shift*5;
          let side = shift*10 / (7+this.props.src.cards.length);
          let translate = Math.pow(Math.abs(shift), 1.3)*0.6;
          let style = { transform: "rotateZ(" + deg + "deg) translateY(" + translate + "vw)", left: "calc(50% - 5vw " + (shift >= 0 ? "+" : "-") + " " + Math.abs(side*10) + "vw)" };
          return (
            <div id={"gg-card-" + c.key} key={c.key+"-"+this.props.src.master.run.champion.level}
            className="game-hand-card"
            style={style}
            onMouseMove={() => this.info(c)}
            onPointerDown={e => {
              if (e.pointerType === "touch")
                this.info(c);
              if (this.props.hidden)
                return;
              this.props.onSelect(e, c); 
            }}>
              <div className={"game-card-wrapper " + this.props.getHalo(c) + (focus ? " card-focus" : "") + (c.locked || c.overloaded ? " card-locked" : "")}>
                <Card src={c}/>
                { !this.props.hidden && (c.volatile || c.overloaded) ? <div className="card-volatile"/> : "" }
                { !this.props.hidden && c.burning ? <div className="card-burning"/> : "" }
                { !this.props.hidden && c.recoveryGlowActive ? <div className="card-recovery"/> : "" }
                { !this.props.hidden && c.corruptGlowActive ? <div className="card-corrupt"/> : "" }
              </div>
            </div>
          );
        })
      }
      {
        this.props.src.master.run.companion ?
        <div className={"game-companion-skill " + (this.props.getSkillHalo()) + (this.props.src.master.player.spentSkill ? " game-companion-skill-locked" : "")}
            onMouseMove={() => this.info(this.props.src.master.run.companion)}
            onPointerDown={e => {
              if (e.pointerType === "touch")
                this.info(this.props.src.master.run.companion);
              if (this.props.hidden)
                return;
              this.props.onSkill(e); 
            }}>
          <div className="game-companion-skill-inner">
            <Img className="game-companion-skill-img" src={this.props.src.master.run.companion.model.skill.img}/>
            <Img className="game-companion-skill-mana" src="/images/frames/skill.png"/>
            <div className="game-companion-skill-mana-value">{this.props.src.master.run.champion.getPassive("freeskill") ? 0 : this.props.src.master.run.companion.model.skill.mana}</div>
          </div>
        </div> : ""
      }
      {
        this.props.src.master.run.champion.model.key === 5 &&
        <div className={"game-stance game-stance-" + (this.props.src.master.player.hasStatus('facing-back') ? "back" : "forward")}>
          {this.props.src.master.player.hasStatus('facing-back') ? "Back" : "Forward"}
        </div>
      }
      </div>
    );
  }
}

